import {useState, useRef, useEffect} from "react";
import {Info} from "lucide-react";
import "./TradingCupInfo.scss"; // import SCSS styles

const TradingCupInfo = () => {
  const [showTooltip, setShowTooltip] = useState(false);
  const [tooltipPosition, setTooltipPosition] = useState("center");
  const tooltipRef = useRef(null);
  const containerRef = useRef(null);

  useEffect(() => {
    if (showTooltip && containerRef.current) {
      const container = containerRef.current;
      const containerRect = container.getBoundingClientRect();
      const viewportWidth = window.innerWidth;
      const tooltipWidth = 340;

      // Calculate where the icon is positioned
      const iconCenterX = containerRect.left + containerRect.width / 2;

      // Calculate if tooltip would overflow when centered
      const tooltipLeft = iconCenterX - tooltipWidth / 2;
      const tooltipRight = iconCenterX + tooltipWidth / 2;

      // Determine position based on icon location and potential overflow
      if (tooltipRight > viewportWidth - 10) {
        // Would overflow right, align to right edge
        setTooltipPosition("right");
      } else if (tooltipLeft < 10) {
        // Would overflow left, align to left edge
        setTooltipPosition("left");
      } else {
        // Enough space to center
        setTooltipPosition("center");
      }
    }
  }, [showTooltip]);

  return (
    <div
      ref={containerRef}
      className="trading-cup-info"
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
    >
      <Info className="info-icon" />

      {showTooltip && (
        <div
          ref={tooltipRef}
          className={`tooltip-box tooltip-${tooltipPosition}`}
        >
          <p className="tooltip-title">Equity Edge Trading Competition</p>
          <p className="tooltip-title">
            This competition will run from <strong>10 November 2025</strong> till <strong>5 December 2025</strong>.
          </p>

          <div className="section">
            <p className="tooltip-title">Prizes are as follows:</p>
            <ul>
              <li>1st Place: $10,000</li>
              <li>2nd Place: $5,000</li>
              <li>3rd Place: $2,500</li>
              <li>Next 10 runners up win $250 each.</li>
            </ul>
          </div>

          <div className="section">
            <ul className="rules-list">
              <li>EAs are not allowed.</li>
              <li>
                <strong>Lot size limit per trade:</strong>
                <ul>
                  <li>10 lots FX / XAU / XAGUSD</li>
                  <li>30 lots max Oil / Indices</li>
                </ul>
              </li>
              <li>
                Max number of open consecutive trades at any one time: <strong>5</strong>
              </li>
              <li>
                Max daily drawdown: <strong>6%</strong>
              </li>
              <li>
                Max total drawdown: <strong>12%</strong>
              </li>
            </ul>
          </div>

          <div className="section">
            <ul className="rules-list">
              <li>Taking advantage of unrealistic fills in the demo environment is not allowed.</li>
              <li>Hedging between accounts is not allowed.</li>
              <li>Prohibited trading strategies as per our FAQ is not allowed.</li>
              <li>You can enter as many times as you like using the same email address. You may not enter using multiple email addresses.</li>
            </ul>
          </div>
        </div>
      )}
    </div>
  );
};

export default TradingCupInfo;
